import {
  DeeplinkParams,
  getDeeplinkParamsFromSearch,
  getSearchStringFromServerRequestUrl,
} from '../utils/deeplink-params';
import { useFeatureServices } from './use-feature-services';

export function useDeeplinkParams(): DeeplinkParams {
  const { 's2:server-request': serverRequest } = useFeatureServices();

  const search =
    typeof window !== 'undefined'
      ? window.location.search
      : getSearchStringFromServerRequestUrl(serverRequest?.url ?? '');

  return getDeeplinkParamsFromSearch(search);
}
